/**
 * @Author: Nenad Brcic
 * @Date: 31.05.16
 * @Email: neno@neno.ch
 */

import React, { PropTypes } from 'react';
import Markdown from '../shared/Markdown'
import styles from './About.scss';
import CSSModules from 'react-css-modules';

const About = (props) => (
    <div styleName="about">
        { !!props.staticText.StaMarkdown ? (
            <Markdown source={ props.staticText.StaMarkdown } />
        ) : null }
    </div>
);

export default CSSModules(About, styles);


// WEBPACK FOOTER //
// ./app/components/About/About.jsx